// The schema-capable side of the service list — which providers can hold
// stored schemas. Shared by the Studio and the pipeline-detail flow card.
//
// Every schema-capable service has a store of its own (the engine's
// /services/{name}/schemas), so the Studio lists all of them and names
// the service on every schema it reads or saves (TTTL-319). The engine's
// schema_registry_for backs MongoDB (a collection in the service's own
// database) and Pub/Sub (the GCP schema API); Kafka has no store.

export const SCHEMA_CAPABLE_PROVIDERS = new Set(["mongodb", "pubsub"]);

export function isSchemaCapableProvider(provider: string): boolean {
  return SCHEMA_CAPABLE_PROVIDERS.has(provider);
}

/** Every service that can store schemas, in service-list order. Empty
 *  while the list is unknown. */
export function schemaCapableServices<
  T extends { name: string; provider: string },
>(services: readonly T[] | null | undefined): T[] {
  return (services ?? []).filter((s) => isSchemaCapableProvider(s.provider));
}
